import { render, staticRenderFns } from "./BookingCreate.vue?vue&type=template&id=f2267e6e&"
import script from "./BookingCreate.vue?vue&type=script&lang=ts&"
export * from "./BookingCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports